import React, { useEffect, useState } from 'react';
import { useToaster } from '../../../Toaster/Toaster';
import { useLoader } from '../../../Loader/LoaderContext';
import { useNavigate } from 'react-router-dom';
import { getService, postService } from '../../../servce/ApisService';
import { API_ENDPOINTS } from '../../../api';
import AuthorInfo from '../../Portals/leads/AuthorInfo';
import DynamicTextPopup from '../../Portals/Modals/dynamicTextPopup';
import DynamicSuccessPopup from '../../Portals/Modals/DynamicSuccessPopup';
import DateService from '../../../servce/DateService';

function CompanyView() {
  const { showToast } = useToaster();
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [isOpen, setOpen] = useState(false);
  const { setLoading } = useLoader();
  const [data, setData] = useState<any | null>(null);
  const router = useNavigate();
  const onEdit = () => {
    router(
      '/vendorDashboard/activateDashbord/companyViewProfile/companyProfile'
    );
  };
  const leadId = localStorage.getItem('leadId');
  const [userInfo, setUserInfo] = useState<any>(null);
  useEffect(() => {
    if (typeof window !== 'undefined') {
      const storedUserInfo = localStorage.getItem('userInfo');
      if (storedUserInfo) {
        setUserInfo(JSON.parse(storedUserInfo)); // Set userInfo from localStorage
      }
    }
    fetchDetails();
  }, []);

  const fetchDetails = async () => {
    try {
      let url: string;
      const response = await getService(
        API_ENDPOINTS.getCompanyProfile + '?leadId=' + leadId
      ); // Fetch post details using 'id'
      setData(response.data);

      setTimeout(() => {
        setLoading(false); // Stop loader after 500ms
        // setIsLoading(false); // Stop local loading
      }, 500);
    } catch (error) {
      console.error('Error fetching post details:', error);
      setTimeout(() => {
        setLoading(false); // Stop loader in case of error
        // setIsLoading(false);
      }, 500);
    }
  };
  const sendForApproval = () => {
    setShowConfirmation(true);
  };
  const closePopup = () => {
    setOpen(false);
    fetchDetails();
  };
  const handleClosePopup = () => setShowConfirmation(false);
  const saveData = async () => {
    setLoading(true);
    try {
      let payload = {
        ...data,
        leadId: leadId,
        profilingStatus: 'PUBLISHED',
      };

      const response = await postService(
        API_ENDPOINTS.saveCompanyProfile,
        payload
      );
      if (response) {
        setShowConfirmation(false);
        setOpen(true);

        showToast('Profile has been updated successfully.', 'success', '');
      }
    } catch (error: any) {
      // setApiError(error.response?.data?.message);
      console.error('Login error:', error);
      if (error.response?.data?.message === 'Invalid Otp. Please try again.') {
      }
    } finally {
      setLoading(false);
    }
  };
  return (
    <>
      <div className='relative rounded-lg'>
        {/* Background Image */}
        <div className='relative w-full h-[180px]'>
          <img
            src='/images/hospitalMask.svg'
            className='w-full h-full object-cover'
          />
        </div>

        {/* Name, Email, and Badge */}
        {/* <div className='flex justify-between items-center mt-1'>
          <div className='ml-[120px] w-[50%]'>
            <p className='font-bold text-[20px] text-gray-900 flex items-center'>
              <span className='line-clamp-1'>{data?.name || 'NA'}</span>
              {(!data?.profilingStatus ||
                data?.profilingStatus === 'NONE' ||
                data?.profilingStatus == 'SEND_FOR_APPROVAL' ||
                data?.profilingStatus == 'TO_SEND_FOR_APPROVAL') && (
                <span className='ml-3 text-[12px] bg-[#FEF3C7] text-[#92400E] px-2 py-1 rounded-xl text-nowrap'>
                  {!data?.profilingStatus || data?.profilingStatus === 'NONE'
                    ? 'Yet to receive for Approval'
                    : data?.profilingStatus == 'SEND_FOR_APPROVAL'
                    ? `Received for Approval on ${DateService.formatDate(
                        data?.sendForAprvlOn,
                        DateService.formats.DD_MM_YYYY
                      )}`
                    : data?.profilingStatus === 'PUBLISHED'
                    ? `Published on ${DateService.formatDate(
                        data?.publishedOn,
                        DateService.formats.DD_MM_YYYY
                      )}`
                    : data?.profilingStatus === 'TO_SEND_FOR_APPROVAL'
                    ? 'Not sent for approval yet'
                    : ''}
                </span>
              )}
              {data?.profilingStatus === 'PUBLISHED' && (
                <span className='ml-3 text-[12px] bg-[#D1FAE5] text-[#065F46] px-2 py-1 rounded-xl text-nowrap'>
                  {!data?.profilingStatus || data?.profilingStatus === 'NONE'
                    ? 'Yet to send for Approval'
                    : data?.profilingStatus == 'SEND_FOR_APPROVAL'
                    ? 'Awaiting for Approval'
                    : data?.profilingStatus === 'PUBLISHED'
                    ? `Published on ${DateService.formatDate(
                        data?.publishedOn,
                        DateService.formats.DD_MM_YYYY
                      )}`
                    : ''}
                </span>
              )}
            </p>
            <p className='text-sm text-gray-600'>{data?.email || 'NA'}</p>
          </div>

        </div> */}
        {/* Name, Email, and Badge */}
        <div className='flex justify-between items-center mt-2 '>
          <div className='ml-[40px]'>
            <p className='font-bold text-[20px] text-gray-900 flex flex-col-reverse '>
              {data?.name || 'NA'}
              {(!data?.profilingStatus ||
                data?.profilingStatus === 'NONE' ||
                data?.profilingStatus == 'SEND_FOR_APPROVAL' ||
                data?.profilingStatus == 'TO_SEND_FOR_APPROVAL') && (
                <span className='text-[12px] bg-[#FEF3C7] text-[#92400E] px-2 py-1 rounded-xl'>
                  {!data?.profilingStatus || data?.profilingStatus === 'NONE'
                    ? 'Yet to receive for Approval'
                    : data?.profilingStatus == 'SEND_FOR_APPROVAL'
                    ? `Received for Approval on ${DateService.formatDate(
                        data?.sendForAprvlOn,
                        DateService.formats.DD_MM_YYYY
                      )}`
                    : data?.profilingStatus === 'PUBLISHED'
                    ? `Published on ${DateService.formatDate(
                        data?.publishedOn,
                        DateService.formats.DD_MM_YYYY
                      )}`
                    : data?.profilingStatus === 'TO_SEND_FOR_APPROVAL'
                    ? 'Not sent for approval yet'
                    : ''}
                </span>
              )}
              {data?.profilingStatus === 'PUBLISHED' && (
                <span className=' text-[12px] bg-[#D1FAE5] text-[#065F46] px-2 py-1 rounded-xl'>
                  {!data?.profilingStatus || data?.profilingStatus === 'NONE'
                    ? 'Yet to send for Approval'
                    : data?.profilingStatus == 'SEND_FOR_APPROVAL'
                    ? 'Awaiting for Approval'
                    : data?.profilingStatus === 'PUBLISHED'
                    ? `Published on ${DateService.formatDate(
                        data?.publishedOn,
                        DateService.formats.DD_MM_YYYY
                      )}`
                    : ''}
                </span>
              )}
            </p>
            <p className='text-sm text-gray-600'>{data?.email || 'NA'}</p>
          </div>

          <div className='absolute  right-6'>
            {userInfo?.roles === 'PUBLISHER' &&
              data?.profilingStatus === 'SEND_FOR_APPROVAL' && (
                <button
                  className='border border-gray-300 px-4 py-2 rounded-md text-sm text-gray-700'
                  type='button'
                  onClick={onEdit}
                >
                  Edit Profile
                </button>
              )}
            {userInfo?.roles === 'PUBLISHER' &&
              data?.profilingStatus === 'SEND_FOR_APPROVAL' && (
                <button
                  type='submit'
                  className='ml-3 px-7 py-2 gradient-background font-Inter text-white rounded font-bold text-base'
                  onClick={sendForApproval}
                >
                  Approve & Publish profile
                </button>
              )}
          </div>
        </div>

        {/* Additional Content Below */}
        <div className='px-6 mt-6'>
          <div className='bg-white px-6 pb-6'>
            <div className='font-Inter text-base pt-7'>
              <p className='text-base font-semibold text-gray-900 pb-2'>
                Company Info
              </p>
              <div className='scroolCls'>
                <p className='text-gray-800'>{data?.companyInfo || 'NA'}</p>
              </div>
            </div>
            <div className='grid sm:grid-cols-3 font-Inter gap-10 mr-8 pb-5 pt-5'>
              <div>
                <p className='text-sm font-normal text-gray-700 pb-1'>
                  Company Type
                </p>
                <p className='font-semibold text-base text-gray-900'>
                  {data?.type || 'NA'}
                </p>
              </div>
              <div>
                <p className='text-sm font-normal text-gray-700 pb-1'>
                  Contact Person Name
                </p>
                <p className='font-semibold text-base text-gray-900'>
                  {data?.contactPersonName || 'NA'}
                </p>
              </div>
              <div>
                <p className='text-sm font-normal text-gray-700 pb-1'>
                  Phone Number
                </p>
                <p className='font-semibold text-base text-gray-900'>
                  {data?.phoneNo || 'NA'}
                </p>
              </div>
            </div>
            <div className=' font-Inter'>
              <p className='text-sm font-normal text-gray-700 pb-1'>Address</p>
              <p className='font-semibold text-base text-gray-900 pb-4'>
                {[
                  data?.streetAddress,
                  data?.apartment,
                  data?.mtCountryDto?.name,
                  data?.state,
                  data?.city,
                  data?.postalCode,
                ].some((value) => value?.toString().trim())
                  ? [
                      data?.streetAddress,
                      data?.apartment,
                      data?.mtCountryDto?.name,
                      data?.state,
                      data?.city,
                      data?.postalCode,
                    ]
                      .filter((value) => value?.toString().trim())
                      .join(', ')
                  : 'NA'}
              </p>
            </div>
          </div>
        </div>

        <div className='px-6'>
          <AuthorInfo submittedData={data} />
        </div>
      </div>

      {showConfirmation && (
        <DynamicTextPopup
          onClose={handleClosePopup}
          title='  Confirm Profile Update'
          body='You are about to update  profile information. Please review the changes before saving. This action will overwrite the existing details.'
          confirmButtonName='Confirm'
          closeButtonName='Cancel'
          onConfirm={saveData}
        />
      )}
      {isOpen && (
        <DynamicSuccessPopup
          onClose={closePopup}
          title='Profile Published Successfuly'
          body='Your company profile has been successfully Published. '
          closeButtonName='Okay'
        />
      )}
    </>
  );
}

export default CompanyView;
